import PropTypes from 'prop-types';
import React from 'react';
import CompletionDate from '../CompletionDate.jsx';

const InitiativeParticipationStatus = ({
  initiative,
  initiativeParticipation,
}) => {
  return (
    <div>
      <div className="strong">
        {initiativeParticipation.completedAt ? 'Completed' : 'Pending'}
      </div>
      <div className="text-details">
        <CompletionDate
          completedAt={initiativeParticipation.completedAt}
          endDate={initiative.endDate}
        />
      </div>
    </div>
  );
};

InitiativeParticipationStatus.propTypes = {
  initiative: PropTypes.shape({
    endDate: PropTypes.object.isRequired,
  }).isRequired,
  initiativeParticipation: PropTypes.shape({
    completedAt: PropTypes.object,
  }).isRequired,
};

export default InitiativeParticipationStatus;
